export default __webpack_public_path__ + "static/media/red-card.ea5b5a1d.png";